import * as yup from 'yup'

export class VehicleCheckInBackupCamPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInBackupCamPhotoFile?: File = undefined
  vehicleCheckInHasBackupCam?: boolean = undefined
}

export const vehicleCheckInBackupCamPhotoValidationSchema = yup
  .object({
    documentGuid: yup.string().nullable(),
    vehicleCheckInBackupCamPhotoFile: yup.mixed().nullable(),
    vehicleCheckInHasBackupCam: yup.boolean().nullable()
  })
  .test(
    'backup-cam-complete',
    'Upload a Backup Cam photo or select Vehicle Does Not Have Backup Camera.',
    values => {
      const dto = values as VehicleCheckInBackupCamPhotoDto | undefined
      return (
        dto?.vehicleCheckInHasBackupCam === false ||
        Boolean(dto?.vehicleCheckInBackupCamPhotoFile) ||
        Boolean(dto?.documentGuid)
      )
    }
  )
